{
  "helloWorld": "Hallo, Wereld!",
  "clickMe": "Klik hier",
  "healthCheckFailed": "Gezondheidscontrole mislukt",
  "errors": {
    "unexpected": "Er is een onverwachte fout opgetreden"
  },
  "error": {
    "title": "Er ging iets mis",
    "description": "Er is een onverwachte fout opgetreden. U kunt het opnieuw proberen of teruggaan naar de startpagina.",
    "tryAgain": "Opnieuw proberen",
    "goHome": "Naar startpagina"
  },
  "dev": {
    "errorPreview": "Foutvoorbeeld"
  },
  "actions": {
    "label": "Acties",
    "edit": "Bewerken",
    "delete": "Verwijderen",
    "save": "Opslaan",
    "cancel": "Annuleren",
    "expand": "Uitvouwen",
    "collapse": "Invouwen"
  },
  "validation": {
    "tooLong": "Mag maximaal {{max}} tekens bevatten",
    "tooShort": "Verplicht",
    "invalidFormat": "Ongeldig formaat",
    "invalid": "Ongeldige waarde"
  },
  "nav": {
    "workspace": "Werkruimte",
    "controlCenter": "Controlecentrum",
    "jobs": "Vacatures",
    "analytics": "Analyses",
    "company": "Bedrijf",
    "agentCommunications": "Agentcommunicatie",
    "integrations": "Integraties",
    "suggestedCandidates": "Voorgestelde kandidaten",
    "unsolicitedApplications": "Open sollicitaties",
    "team": "Team",
    "templates": "Sjablonen",
    "workflow": "Workflow",
    "settings": "Instellingen",
    "language": "Taal",
    "help": "Help",
    "logout": "Uitloggen",
    "administration": "Beheer",
    "adminTenant": "Tenantinstellingen",
    "adminOrganizations": "Organisaties",
    "adminDepartments": "Afdelingen",
    "adminFeedback": "Feedback",
    "openMenu": "Menu openen",
    "mcp": "MCP",
    "orgSettings": "Organisatie-instellingen"
  },
  "admin": {
    "tenants": {
      "title": "Tenants",
      "newTenant": "Nieuwe tenant",
      "columns": {
        "name": "Naam",
        "createdAt": "Aangemaakt op",
        "actions": "Acties"
      },
      "createDialog": {
        "title": "Tenant aanmaken",
        "namePlaceholder": "Acme Corp"
      },
      "editDialog": {
        "title": "Tenant bewerken"
      }
    },
    "tenant": {
      "title": "Tenantinstellingen",
      "name": "Tenantnaam",
      "save": "Wijzigingen opslaan",
      "saved": "Opgeslagen"
    },
    "organizations": {
      "title": "Organisaties",
      "newOrg": "Nieuwe organisatie",
      "columns": {
        "name": "Naam",
        "slug": "Slug",
        "tenant": "Tenant",
        "createdAt": "Aangemaakt op",
        "actions": "Acties",
        "viewWorkspace": "Werkruimte bekijken"
      },
      "createDialog": {
        "title": "Organisatie aanmaken",
        "namePlaceholder": "Acme Corp",
        "slugPlaceholder": "acme-corp",
        "newTenant": "Nieuwe tenant",
        "existingTenant": "Bestaande tenant",
        "tenantName": "Tenantnaam",
        "tenantNamePlaceholder": "Acme Corp",
        "selectTenant": "Tenant selecteren"
      },
      "editDialog": {
        "title": "Organisatie bewerken",
        "language": "Taal",
        "languagePlaceholder": "Taal selecteren"
      },
      "deleteConfirm": {
        "title": "Organisatie verwijderen",
        "description": "Dit verwijdert ook alle afdelingen in deze organisatie. Deze actie kan niet ongedaan worden gemaakt.",
        "confirm": "Verwijderen",
        "cancel": "Annuleren"
      }
    },
    "departments": {
      "title": "Afdelingen",
      "newDept": "Nieuwe afdeling",
      "columns": {
        "name": "Naam",
        "slug": "Slug",
        "createdAt": "Aangemaakt op",
        "actions": "Acties"
      },
      "createDialog": {
        "title": "Afdeling aanmaken",
        "namePlaceholder": "Engineering",
        "slugPlaceholder": "engineering"
      },
      "editDialog": {
        "title": "Afdeling bewerken"
      },
      "deleteConfirm": {
        "title": "Afdeling verwijderen",
        "description": "Deze actie kan niet ongedaan worden gemaakt.",
        "confirm": "Verwijderen",
        "cancel": "Annuleren"
      }
    },
    "viewingOrg": {
      "banner": "Bekijken: {{name}}",
      "leave": "Verlaten"
    },
    "feedback": {
      "title": "Feedback",
      "columns": {
        "rating": "Beoordeling",
        "modality": "Type",
        "candidate": "Kandidaat",
        "job": "Vacature",
        "org": "Organisatie",
        "notes": "Opmerkingen",
        "date": "Datum"
      },
      "modality": {
        "voice": "Stem",
        "text": "Chat"
      },
      "thumbs": {
        "up": "Positief",
        "down": "Negatief"
      },
      "filter": {
        "all": "Alles",
        "up": "Positief",
        "down": "Negatief",
        "hasNotes": "Met opmerkingen"
      },
      "stats": {
        "title": "Negatief percentage",
        "period": "Laatste 7 dagen",
        "wowUp": "+{{delta}}pp",
        "wowDown": "-{{delta}}pp",
        "wowFlat": "Geen verandering",
        "wowNoPrev": "Geen vorige data",
        "noData": "Geen data"
      },
      "noFeedback": "Nog geen feedback",
      "noNotes": "Geen geschreven opmerking"
    }
  },
  "team": {
    "title": "Team",
    "invite": "Collega's uitnodigen",
    "search": "Zoek op naam, e-mail, afdeling...",
    "department": "Afdeling",
    "roles": {
      "admin": "Beheerder",
      "org_manager": "Organisatiebeheerder",
      "dept_manager": "Afdelingsbeheerder",
      "user": "Gebruiker"
    },
    "columns": {
      "name": "Naam",
      "email": "E-mail",
      "role": "Rol",
      "actions": "Acties"
    },
    "inviteDialog": {
      "title": "Collega uitnodigen",
      "name": "Naam",
      "namePlaceholder": "Jan Jansen",
      "email": "E-mailadres",
      "emailPlaceholder": "collega@bedrijf.nl",
      "role": "Rol",
      "departments": "Afdelingen",
      "submit": "Uitnodiging versturen"
    },
    "actions": {
      "changeRole": "Rol wijzigen",
      "addDepartment": "Aan afdeling toevoegen",
      "removeDepartment": "Uit afdeling verwijderen",
      "removeFromOrg": "Uit organisatie verwijderen"
    },
    "noResults": "Geen resultaten gevonden.",
    "noMembers": "Nog geen teamleden."
  },
  "jobs": {
    "title": "Vacatures",
    "backToJobs": "Vacatures",
    "newJob": "Nieuwe vacature",
    "createNewJob": "Nieuwe vacature aanmaken",
    "importFromAts": "Importeren uit {{atsName}}",
    "searchPlaceholder": "Vacatures zoeken...",
    "completedPlaceholder": "{{completed}} van {{total}} voltooid",
    "tabs": {
      "active": "Actief",
      "archived": "Gearchiveerd"
    },
    "columns": {
      "name": "Naam",
      "createdBy": "Aangemaakt door",
      "createdAt": "Aangemaakt op",
      "actions": "Acties"
    },
    "empty": "Geen vacatures gevonden.",
    "emptyTitle": "Nog geen vacatures",
    "emptyDescription": "Maak uw eerste vacature aan of importeer vanuit uw ATS om te beginnen.",
    "emptyArchivedTitle": "Geen gearchiveerde vacatures",
    "emptyArchivedDescription": "Gearchiveerde vacatures verschijnen hier.",
    "emptySearchDescription": "Geen vacatures komen overeen met uw zoekopdracht.",
    "actions": {
      "archive": "Archiveren",
      "archiveConfirmTitle": "Vacature archiveren",
      "archiveConfirmDescription": "Weet u zeker dat u deze vacature wilt archiveren? Deze wordt verplaatst naar het tabblad Gearchiveerd.",
      "archiveSuccess": "Vacature gearchiveerd",
      "archiveError": "Kan vacature niet archiveren. Probeer het opnieuw."
    },
    "createError": "Vacature aanmaken mislukt. Probeer het opnieuw.",
    "status": {
      "active": "Actief",
      "archived": "Gearchiveerd"
    },
    "setupStatus": {
      "draft": "Concept",
      "questions_pending": "Instelling nodig",
      "ready": "Gereed",
      "active": "Actief"
    },
    "applicantSync": {
      "syncingBanner": "Kandidaten ophalen van {{provider}}...",
      "failedBanner": "Kandidaatsynchronisatie mislukt",
      "adminActions": "Beheeracties",
      "resyncLabel": "Kandidaten nu synchroniseren",
      "lastSyncedAt": "Laatst gesynchroniseerd op: {{date}}",
      "addDemoApplicant": "Demokandidaat toevoegen"
    },
    "detail": {
      "tabs": {
        "candidates": "Kandidaten",
        "results": "Resultaten",
        "settings": "Instellingen"
      },
      "info": {
        "title": "Vacature-informatie",
        "employer": "Werkgever",
        "location": "Locatie",
        "description": "Beschrijving",
        "modality": "Interviewvorm",
        "languages": "Talen",
        "atsProvider": "ATS-aanbieder",
        "atsId": "ATS-vacature-ID",
        "noDescription": "Geen beschrijving opgegeven."
      },
      "questions": {
        "title": "Interviewvragen",
        "empty": "Geen vragen geconfigureerd voor deze vacature.",
        "optional": "Optioneel",
        "categories": {
          "eligibility": "Geschiktheid",
          "nice_to_have": "Mooi meegenomen",
          "job_preview": "Functieverwachtingen",
          "assessment": "Beoordeling",
          "information": "Informatie"
        }
      }
    }
  },
  "wizard": {
    "step": "Stap {{current}} van {{total}}",
    "back": "Terug",
    "next": "Doorgaan",
    "goLive": "Live zetten",
    "saveAndContinue": "Opslaan & doorgaan",
    "manual": {
      "title": "Nieuwe vacature",
      "step1Title": "Basisinformatie",
      "step2Title": "Interviewvragen",
      "step3Title": "Bevestigen & live zetten"
    },
    "import": {
      "title": "Importeren uit ATS",
      "step0Title": "Vacatures selecteren",
      "step1Title": "Fases koppelen",
      "step2Title": "Interviewinstellingen",
      "step3Title": "Interviewvragen",
      "step4Title": "Bevestigen & live zetten"
    },
    "stageSelector": {
      "title": "Pipelinefases koppelen",
      "description": "Selecteer welke fase in elke vacature overeenkomt met elke Kiku-actie. Vooraf ingevuld waar fasenamen overeenkwamen met uw standaardwaarden.",
      "continue": "Doorgaan",
      "loading": "Fases laden..."
    },
    "basicInfo": {
      "title": "Vacaturetitel",
      "titlePlaceholder": "bijv. Senior Software Engineer",
      "description": "Vacaturebeschrijving",
      "descriptionPlaceholder": "Beschrijf de rol, verantwoordelijkheden en vereisten...",
      "descriptionHint": "Wordt gebruikt door AI om relevante interviewvragen te genereren",
      "employer": "Werkgeversnaam (optioneel)",
      "employerPlaceholder": "bijv. Acme Corp",
      "modality": "Interviewvorm",
      "modalityText": "Tekstchat",
      "modalityTextDesc": "Kandidaat typt antwoorden in een chatinterface",
      "modalityVoice": "Steminterview",
      "modalityVoiceDesc": "Live audio-interview in een virtuele vergaderruimte",
      "languages": "Interviewtaal/talen",
      "languagesHint": "Selecteer ten minste één taal",
      "languagesSearch": "Talen zoeken...",
      "languagesEmpty": "Geen taal gevonden.",
      "modalityRequired": "Selecteer ten minste één interviewvorm",
      "languagesRequired": "Selecteer ten minste één taal"
    },
    "atsSelector": {
      "title": "Selecteer vacatures om te importeren",
      "search": "Vacatures zoeken...",
      "selectAll": "Alles selecteren",
      "selected": "{{count}} geselecteerd",
      "noJobs": "Geen actieve vacatures gevonden in uw ATS",
      "noDescription": "Geen beschrijving beschikbaar — AI genereert op basis van alleen de titel",
      "continue": "Doorgaan met {{count}} vacature(s)"
    },
    "sharedSettings": {
      "title": "Interviewinstellingen",
      "subtitle": "Deze instellingen gelden voor alle geïmporteerde vacatures",
      "employer": "Naam werkgever",
      "employerPlaceholder": "bijv. Acme Corp"
    },
    "questions": {
      "title": "Interviewvragen",
      "generateError": "Vragen genereren mislukt. Probeer het opnieuw.",
      "retry": "Opnieuw proberen",
      "generating": "Vragen worden voorbereid om de beste kandidaten te vinden…",
      "generatingHint": "Dit duurt meestal enkele seconden",
      "addQuestion": "Vraag toevoegen",
      "categories": {
        "eligibility": "Geschiktheid",
        "nice_to_have": "Mooi meegenomen",
        "job_preview": "Realistische functieomschrijving",
        "assessment": "Beoordeling",
        "information": "Informatieverzameling"
      },
      "categoryDescriptions": {
        "eligibility": "Ja/nee-vragen over harde vereisten",
        "nice_to_have": "Ja/nee-vragen over wenselijke maar niet-verplichte kwalificaties",
        "job_preview": "Belicht een uitdagend aspect van de rol. Helpt ervoor te zorgen dat een kandidaat begrijpt wat de rol inhoudt en voorkomt verloop op termijn",
        "assessment": "Gedrags- en competentievragen",
        "information": "Vragen voor het verzamelen van context — niet gebruikt bij scoring"
      },
      "categoryPurpose": {
        "eligibility": "Geslaagd of gezakt",
        "job_preview": "Geslaagd of gezakt",

        "assessment": "Gescoord",
        "information": "Alleen ter informatie"
      },
      "optional": "Optioneel",
      "competency": "Competentie",
      "scoringExamples": "Scoringsankers",
      "editScoringExamples": "Scoringsankers bewerken",
      "regenerateScoringExamples": "Scoringsankers opnieuw genereren",
      "dontRegenerateScoringExamples": "Scoringsankers niet opnieuw genereren",
      "regeneratingScoringExamples": "Opnieuw genereren...",
      "regenerateScoringError": "Scoringsankers opnieuw genereren mislukt",
      "score1": "Score 1 — Slecht",
      "score3": "Score 3 — Voldoende",
      "score5": "Score 5 — Uitstekend",
      "aiGenerated": "AI-gegenereerd"
    },
    "confirm": {
      "title": "Klaar om live te gaan",
      "jobsCount": "{{count}} vacature(s) worden geactiveerd",
      "questionsCount": "{{count}} interviewvraag/vragen",
      "modality": "Vorm",
      "languages": "Talen",
      "goLiveHint": "Kandidaten kunnen direct na activering met interviews beginnen."
    }
  },
  "login": {
    "title": "Inloggen bij Kiku",
    "subtitle": "Beheer uw wervingspipeline.",
    "cta": "Inloggen",
    "waitingForLogin": "Wachten op inloggen...",
    "disclosure": "U communiceert met een AI-systeem. Kiku gebruikt AI om te helpen bij werving — alle beslissingen worden door mensen beoordeeld.",
    "errors": {
      "not_provisioned": "Uw account is nog niet ingesteld. Neem contact op met uw beheerder.",
      "missing_code": "Authenticatie mislukt. Probeer het opnieuw.",
      "session_expired": "Uw sessie is verlopen. Log opnieuw in."
    }
  },
  "settings": {
    "profile": {
      "title": "Profiel",
      "name": "Naam",
      "email": "E-mail",
      "role": "Rol",
      "departments": "Afdelingen"
    }
  },
  "integrations": {
    "title": "Integraties",
    "ats": {
      "title": "ATS-verbinding",
      "description": "Verbind uw Applicant Tracking System om vacatures te synchroniseren en kandidaatfases te beheren.",
      "provider": "Aanbieder",
      "apiKey": "API Key",
      "apiKeyPlaceholder": "Voer uw API Key in",
      "apiKeySet": "Sleutel opgeslagen — voer een nieuwe waarde in om te vervangen",
      "save": "Verbinding opslaan",
      "verify": "Verbinding verifiëren",
      "verifyStatus": {
        "valid": "Verbonden",
        "invalid": "Ongeldige sleutel",
        "error": "Verificatie mislukt",
        "idle": "Niet geverifieerd",
        "loading": "Verifiëren..."
      },
      "providers": {
        "teamtailor": "Teamtailor",
        "recman": "RecMan",
        "logicmelon": "LogicMelon",
        "teamtailorDescription": "Teamtailor is een recruitmentplatform dat bedrijven helpt topkandidaten aan te trekken, te begeleiden en aan te nemen.",
        "recmanDescription": "RecMan is een recruitmentsysteem voor uitzendbureaus en recruitmentbureaus op de Scandinavische markt.",
        "logicmelonDescription": "LogicMelon is een multi-posting ATS voor hoogvolume werving, populair in de Britse onderwijssector."
      }
    },
    "stageMapping": {
      "title": "Fasekoppeling",
      "description": "Koppel uw ATS-fases aan Kiku-workflowfases.",
      "initialStage": "Beginfase",
      "passInterviewStage": "Interview geslaagd",
      "failInterviewStage": "Interview gezakt",
      "recommendedStage": "Aanbevolen",
      "selectStage": "Selecteer een fase",
      "save": "Koppeling opslaan"
    },
    "errors": {
      "notConfigured": "Geen ATS geconfigureerd. Sla eerst uw verbinding op.",
      "fetchStagesFailed": "Kan fases niet laden vanuit uw ATS.",
      "saveFailed": "Opslaan van configuratie mislukt."
    }
  },
  "applications": {
    "title": "Sollicitaties",
    "newCandidate": "Nieuwe kandidaat",
    "addCandidate": "Nieuwe kandidaat toevoegen",
    "importFromCsv": "Importeren uit CSV",
    "importDialog": {
      "title": "Kandidaten importeren",
      "back": "Terug",
      "next": "Volgende",
      "upload": {
        "hint": "Sleep een CSV-bestand hierheen, of klik om te bladeren",
        "csvOnly": "Alleen CSV-bestanden",
        "browse": "Bladeren"
      },
      "mapping": {
        "headerRow": "Eerste rij is een koptekst",
        "nameColumn": "Naamkolom",
        "emailColumn": "E-mailkolom",
        "phoneColumn": "Telefoonkolom",
        "notMapped": "— niet gekoppeld —",
        "column": "Kolom",
        "preview": "Voorbeeld"
      },
      "review": {
        "allValid": "Alle {{count}} kandidaten zijn geldig",
        "summary": "{{valid}} geldig · {{invalid}} ongeldig",
        "skipInvalid": "Ongeldige rijen overslaan en {{count}} geldige kandidaten importeren",
        "recheck": "Opnieuw controleren",
        "import": "{{count}} kandidaten importeren",
        "colName": "Naam",
        "colEmail": "E-mail",
        "colPhone": "Telefoon",
        "colStatus": "Status"
      },
      "errors": {
        "nameRequired": "Verplicht",
        "emailInvalid": "Ongeldig e-mailadres",
        "emailDuplicate": "Dubbel e-mailadres in dit bestand",
        "phoneInvalid": "Landcode vereist (bijv. +31...)"
      },
      "success": {
        "title": "Import voltooid",
        "body": "{{created}} geïmporteerd, {{conflict}} hadden al sollicitaties (overgeslagen), {{error}} mislukt.",
        "done": "Klaar"
      }
    },
    "screening": "Screening",
    "aiRanked": "AI-gerangschikt",
    "emptyStage": "Geen sollicitaties",
    "emptyTitle": "Nog geen kandidaten",
    "emptyDescription": "Voeg uw eerste kandidaat toe om sollicitaties te bekijken.",
    "emptySearchDescription": "Geen kandidaten komen overeen met uw zoekopdracht.",
    "searchPlaceholder": "Zoek op naam, e-mail of telefoon",
    "createDialog": {
      "title": "Sollicitatie toevoegen",
      "name": "Volledige naam",
      "namePlaceholder": "bijv. Jan Jansen",
      "email": "E-mailadres",
      "emailPlaceholder": "bijv. jan@voorbeeld.nl",
      "phoneNumber": "Telefoonnummer",
      "phoneNumberPlaceholder": "bijv. 06-12345678",
      "phoneCountryCode": "Landcode",
      "phoneCountryCodePlaceholder": "bijv. +31",
      "submit": "Sollicitatie aanmaken"
    },
    "errors": {
      "conflict": "Deze kandidaat heeft al een sollicitatie voor deze vacature."
    },
    "detail": {
      "title": "Sollicitatiedetails",
      "tabs": {
        "application": "Sollicitatie",
        "profile": "Profiel",
        "activity": "Activiteit"
      },
      "stage": "Fase",
      "interviewLink": "Interviewlink",
      "interviewStatus": "Interviewstatus",
      "copyLink": "Link kopiëren",
      "linkCopied": "Gekopieerd!",
      "noInterview": "Geen interviewsessie gevonden",
      "noResults": {
        "title": "Interview niet voltooid",
        "description": "Deze kandidaat heeft het interview nog niet gedaan. Deel de interviewlink om te beginnen."
      },
      "inProgress": {
        "title": "Interview bezig",
        "description": "Deze kandidaat is begonnen met het interview. De resultaten verschijnen hier zodra het afgerond is."
      },
      "openInterview": "Interview openen",
      "commChannel": {
        "label": "Versturen via",
        "manual": "Handmatig",
        "email": "E-mail",
        "sms": "SMS",
        "whatsapp": "WhatsApp"
      },
      "status": {
        "pending": "In afwachting",
        "in_progress": "Bezig",
        "completed": "Voltooid",
        "expired": "Verlopen"
      }
    }
  },
  "pagination": {
    "rowsPerPage": "Rijen per pagina",
    "rowsSelected": "{{count}} van {{total}} rij(en) geselecteerd.",
    "pageOf": "Pagina {{page}} van {{total}}",
    "previous": "Vorige",
    "next": "Volgende"
  },
  "screening": {
    "title": "Screeninginterview",
    "aiDisclosure": "U chat met Sara, een AI-wervingsassistent",
    "selectLanguage": "Selecteer uw voorkeurstaal",
    "selectLanguageDescription": "Het interview wordt afgenomen in de taal die u kiest",
    "startInterview": "Interview starten",
    "previewJobTitle": "Voorbeeldvacature — Voorbeeldbedrijf",
    "typeMessage": "Typ uw bericht...",
    "send": "Versturen",
    "typing": "Sara typt...",
    "submitInterview": "Interview indienen",
    "loading": "Interview laden...",
    "completed": {
      "title": "Interview voltooid",
      "submitted": "Interview succesvol ingediend",
      "message": "Bedankt voor het voltooien van het interview voor {{jobTitle}}. Een recruiter zal uw antwoorden beoordelen en neemt contact met u op."
    },
    "expired": {
      "title": "Interview verlopen",
      "message": "Deze interviewlink is verlopen. Neem contact op met de recruiter voor een nieuwe uitnodiging."
    },
    "notFound": {
      "title": "Interview niet gevonden",
      "message": "Deze interviewlink is niet geldig. Controleer de link en probeer het opnieuw."
    },
    "feedback": {
      "helpUsImprove": "Help ons verbeteren",
      "teaser": "Hoe was de interviewervaring?",
      "overallPrompt": "Hoe was de algehele interviewervaring?",
      "disclaimer": "We horen graag uw feedback — deze is anoniem en heeft geen invloed op uw sollicitatie.",
      "prompt": "Hoe ging het interview?",
      "good": "Goed",
      "bad": "Slecht",
      "notesLabel": "Heeft u nog aanvullende opmerkingen?",
      "notesPlaceholder": "Vertel ons meer (optioneel)...",
      "skip": "Overslaan",
      "submit": "Feedback indienen",
      "submitError": "Feedback indienen mislukt. Probeer het opnieuw."
    },
    "technicalIssue": {
      "buttonLabel": "Technisch probleem?",
      "modalTitle": "Technisch probleem melden",
      "modalDescription": "Beschrijf het probleem dat u tegenkwam. Uw feedback wordt verzonden en het interview wordt opnieuw gestart.",
      "notesLabel": "Wat ging er mis?",
      "notesPlaceholder": "bijv. De pagina bevroor en ik verloor mijn voortgang...",
      "submitButton": "Feedback versturen en opnieuw starten",
      "submitError": "Verzenden mislukt. Probeer het opnieuw.",
      "cancel": "Annuleren"
    },
    "error": {
      "title": "Er ging iets mis",
      "message": "Er is een fout opgetreden. Probeer het later opnieuw.",
      "sendFailed": "Bericht verzenden mislukt. Probeer het opnieuw."
    },
    "languages": {
      "en": "Engels",
      "da": "Deens",
      "sv": "Zweeds",
      "de": "Duits",
      "fr": "Frans",
      "es": "Spaans",
      "nl": "Nederlands",
      "pl": "Pools",
      "fi": "Fins",
      "ro": "Roemeens"
    },
    "landing": {
      "badge": "SOLLICITATIEGESPREK",
      "greeting": "Hallo {{name}}! Leuk dat je er bent. Dit is een uitnodiging voor een kort online screeninginterview met een AI om je beter te leren kennen. Doe het wanneer je er klaar voor bent.",
      "startChat": "Start chatinterview",
      "startVoice": "Start steminterview",
      "or": "of",
      "minutes": "{{count}} minuten",
      "questions": "{{count}} vragen"
    },
    "modality": {
      "title": "Kies interviewvorm",
      "description": "Selecteer hoe u het interview wilt afleggen",
      "text": "Tekstinterview",
      "textDescription": "Typ uw antwoorden in een chat",
      "voice": "Steminterview",
      "voiceDescription": "Spreek uw antwoorden hardop uit"
    },
    "deviceTest": {
      "title": "Controleer uw audio",
      "description": "Zorg ervoor dat uw microfoon en luidsprekers werken voordat u begint",
      "microphone": "Microfoon",
      "speakers": "Luidsprekers",
      "testMicrophone": "Microfoontoegang toestaan",
      "testSpeakers": "Testgeluid afspelen",
      "playAgain": "Opnieuw afspelen",
      "requestingPermission": "Toestemming aanvragen...",
      "microphoneDenied": "Microfoontoegang is geweigerd. Sta toegang toe in uw browserinstellingen.",
      "confirm": "Alles werkt — interview starten"
    },
    "voice": {
      "title": "Steminterview",
      "connecting": "Verbinden...",
      "recording": "Opnemen",
      "interviewInProgress": "Interview bezig",
      "inProgress": "Interview bezig — spreek op een natuurlijke manier",
      "muted": "Uw microfoon is gedempt",
      "finished": "Interview voltooid — bedankt!",
      "alreadyInProgress": "Interview bezig",
      "alreadyInProgressMessage": "Uw steminterview is momenteel actief. Opnieuw starten annuleert de huidige sessie — doe dit alleen als u niet meer verbonden bent.",
      "retryButton": "Interview opnieuw starten"
    }
  },
  "scoring": {
    "title": "Interviewresultaten",
    "pending": "Scoring bezig...",
    "processing": "AI evalueert het interview...",
    "failed": "Scoring mislukt",
    "overallScore": "Totaalscore",
    "overallScoreTooltip": "Score van 0–100 gebaseerd op het gemiddelde van alle beoordelingsvragen, aangepast voor geschiktheid en functieverwachtingen.",
    "outcome": "Uitkomst",
    "outcomes": {
      "pass": "Geslaagd",
      "fail": "Gezakt"
    },
    "summary": "Samenvatting",
    "eligibility": "Geschiktheid",
    "niceToHave": "Mooi meegenomen",
    "expectations": "Functieverwachtingen",
    "assessment": "Beoordeling",
    "information": "Informatieverzameling",
    "scoringAnchors": "Scoringsankers",
    "candidateAnswer": "Antwoord van kandidaat",
    "transcript": "Interviewtranscript",
    "viewInTranscript": "Bekijk in transcript",
    "copyPasteDetected": "Gekopieerd en geplakt antwoord",
    "copyPasteWarning": "Kopiëren en plakken gedetecteerd in dit interview",
    "copyPasteWarningTooltip": "Een of meer antwoorden van de kandidaat zijn geplakt tijdens het interview. Dit kan erop wijzen dat de kandidaat vooraf geschreven antwoorden heeft gebruikt.",
    "verdicts": {
      "pass": "Geslaagd",
      "fail": "Gezakt",
      "unsure": "Onzeker",
      "review": "Beoordeling nodig"
    },
    "optional": "Optioneel",
    "averageScore": "Gemiddelde vraagscore",
    "reasoning": "Redenering",
    "evidence": "Bewijs",
    "backToJob": "Terug naar vacature",
    "overrideDialog": {
      "title": "Score overschrijven",
      "titleVerdict": "Uitspraak overschrijven",
      "currentValue": "Huidige waarde",
      "newValue": "Nieuwe waarde",
      "reason": "Reden voor overschrijving",
      "reasonPlaceholder": "Leg uit waarom u deze score wijzigt...",
      "reasonMinLength": "Minimaal {{min}} tekens vereist",
      "save": "Overschrijving opslaan",
      "cancel": "Annuleren",
      "error": "Overschrijving opslaan mislukt. Probeer het opnieuw."
    }
  },
  "workflows": {
    "title": "Workflow",
    "description": "Configureer de fases die sollicitaties doorlopen tijdens uw wervingsproces.",
    "stages": {
      "title": "Pipelinefases",
      "subtitle": "Sleep om te herordenen. Sollicitaties doorlopen deze fases van boven naar beneden.",
      "system": "Systeem",
      "manage": "Fases beheren",
      "addStage": "Fase toevoegen",
      "editStage": "Fase bewerken",
      "deleteStage": "Fase verwijderen",
      "stageName": "Fasenaam",
      "stageNamePlaceholder": "bijv. Telefonisch gesprek",
      "stageColor": "Kleur",
      "deleteConfirm": "Deze fase verwijderen? Sollicitaties in deze fase moeten eerst verplaatst worden.",
      "systemProtected": "Systeemfases kunnen niet worden verwijderd",
      "hasApplications": "Deze fase heeft nog sollicitaties toegewezen"
    }
  },
  "communications": {
    "title": "Agentcommunicatie",
    "languageSelector": "Taal",
    "tabs": {
      "sms": "SMS",
      "email": "E-mail"
    },
    "emailSubject": "Onderwerp",
    "emailBody": "Inhoud",
    "variables": {
      "applicantName": "Naam sollicitant",
      "jobTitle": "Vacaturetitel",
      "jobEmployer": "Werkgever",
      "jobLocation": "Locatie",
      "jobDescription": "Vacaturebeschrijving",
      "recruiterName": "Naam recruiter",
      "inviteUrl": "Uitnodigings-URL"
    },
    "actions": {
      "edit": "Bewerken",
      "save": "Wijzigingen opslaan",
      "reset": "Standaardwaarden herstellen",
      "saved": "Sjabloon opgeslagen",
      "resetDone": "Standaardwaarden hersteld"
    },
    "nodes": {
      "interviewIntro": "Interview-intro",
      "interviewOutro": "Interview-outro",
      "reminderToFinish": "Herinnering om af te ronden",
      "voiceAndChat": "Stem & Chat",
      "emailsAndSms": "E-mails & SMS",
      "comingSoon": "Binnenkort beschikbaar"
    },
    "characters": "{{count}}/{{max}} Tekens",
    "smsSegments": "{{count}} SMS-berichten ({{size}} tekens/segment)",
    "smsUnicodeWarning": "Dit bericht bevat emoji's of speciale tekens die Unicode-codering vereisen, waardoor de limiet wordt verlaagd naar 67 tekens per SMS.",
    "invite": {
      "title": "Kandidaatuitnodiging",
      "description": "Kandidaten ontvangen dit wanneer ze aan een vacature worden toegevoegd. De e-mail bevat automatisch een link naar het interview.",
      "email": {
        "subject": "Je bent uitgenodigd voor je {{jobTitle}}-interview! 🎯",
        "body": "<p>Hoi {{applicantName}},</p><p>Je bent uitgenodigd om een kort online screeninginterview met onze AI-interviewer af te leggen voor de functie <strong>{{jobTitle}}</strong> bij <strong>{{jobEmployer}}</strong>.</p><p>Het is een eenvoudige manier voor ons om je beter te leren kennen — doe het wanneer je wilt, waar je maar bent. Het duurt maar een paar minuten!</p><p><a href=\"{{inviteUrl}}\">Start interview</a></p><p>Veel succes!<br>{{jobEmployer}}</p>"
      },
      "sms": "Hoi {{applicantName}}, ik ben Sara, de AI-assistent van {{jobEmployer}}. Je bent uitgenodigd voor een interview voor {{jobTitle}}. Het duurt maar een paar minuten: {{inviteUrl}} (Geen antwoord mogelijk)"
    },
    "reminder": {
      "title": "Interviewherinnering",
      "description": "Wordt automatisch verzonden als een kandidaat het interview niet binnen 24 uur na de uitnodiging heeft gestart.",
      "email": {
        "subject": "Vergeet je {{jobTitle}}-interview niet",
        "body": "<p>Hoi {{applicantName}},</p><p>We zagen dat je je AI-screeninginterview voor de functie <strong>{{jobTitle}}</strong> bij <strong>{{jobEmployer}}</strong> nog niet hebt afgerond.</p><p>Dit is je kans om een stap dichter bij de volgende fase te komen — het duurt maar een paar minuten en het verhoogt je kansen om door te gaan naar de volgende ronde.</p><p><a href=\"{{inviteUrl}}\">Interview nu afronden</a></p><p>Met vriendelijke groet,<br>{{jobEmployer}}</p>"
      },
      "sms": "Hoi {{applicantName}}, een vriendelijke herinnering — je hebt je {{jobTitle}}-interview bij {{jobEmployer}} nog niet afgerond. Het duurt maar een paar minuten en helpt je kansen: {{inviteUrl}} — Sara"
    },
    "emailBodyPlaceholder": "Schrijf uw e-mail...",
    "preview": {
      "outroSampleIntro": "Dat was alles — bedankt voor je antwoorden!",
      "outroSampleAnswer": "Geen probleem, graag gedaan."
    },
    "intro": {
      "title": "Interview-intro",
      "description": "Het exacte openingsbericht dat Sara zegt om de kandidaat te begroeten en te vragen of ze klaar zijn om te beginnen.",
      "scriptLabel": "Introbericht",
      "scriptPlaceholder": "Schrijf het exacte openingsbericht dat Sara moet zeggen...",
      "defaultScript": "Hoi! Ik ben Sara, een AI-wervingsassistent voor {{jobEmployer}}. Bedankt dat je de tijd neemt voor het interview voor de functie {{jobTitle}} — het duurt maar een paar minuten. Ben je klaar om te beginnen? 😊"
    },
    "outro": {
      "title": "Interview-outro",
      "description": "Het exacte afsluitbericht dat Sara zegt nadat alle vragen zijn beantwoord.",
      "scriptLabel": "Outrobericht",
      "scriptPlaceholder": "Schrijf het exacte afsluitbericht dat Sara moet zeggen...",
      "defaultScript": "Dat was alles — heel erg bedankt voor je tijd vandaag! Een recruiter zal je antwoorden beoordelen en neemt contact met je op. Veel succes! 🙂"
    }
  },
  "activity": {
    "title": "Activiteit",
    "stageChange": "Verplaatst van {{from}} naar {{to}}",
    "interviewCompleted": "Screeninginterview voltooid",
    "scoreReceived": "Score ontvangen: {{score}}/100",
    "applicationCreated": "Sollicitatie aangemaakt",
    "noteAdded": "Notitie toegevoegd",
    "bySystem": "Systeem",
    "byAi": "AI",
    "empty": "Nog geen activiteit",
    "emptyTitle": "Nog geen activiteit",
    "emptyDescription": "Acties en gebeurtenissen voor deze kandidaat verschijnen hier."
  },
  "atsPush": {
    "title": "ATS-pushstatus",
    "retry": "ATS-push opnieuw proberen",
    "retrying": "Opnieuw proberen...",
    "rerunStep": "Deze stap opnieuw uitvoeren",
    "rerunConfirm": "Deze stap is al succesvol voltooid. Opnieuw uitvoeren kan dubbele data aanmaken in uw ATS. Doorgaan?",
    "steps": {
      "transcript": "Transcript",
      "stage_move": "Faseverplaatsing"
    },
    "status": {
      "completed": "Verzonden",
      "failed": "Mislukt",
      "pending": "In afwachting"
    },
    "note": {
      "title": "AI-screeninginterview",
      "outcome": "Uitkomst",
      "score": "Score",
      "summary": "Samenvatting",
      "eligibility": "Geschiktheid",
      "assessment": "Beoordeling",
      "transcript": "Transcript",
      "candidate": "Kandidaat",
      "interviewer": "Interviewer",
      "pass": "Geslaagd",
      "fail": "Gezakt",
      "review": "Beoordeling",
      "shortlist": "Shortlist",
      "reject": "Afwijzen",
      "viewProfile": "Bekijk kandidaatprofiel in Kiku",
      "transcriptAndAssessment": "TRANSCRIPT EN BEOORDELING",
      "intro": "Intro",
      "eligibilityQuestions": "Geschiktheidsvragen",
      "jobExpectations": "Functieverwachtingen",
      "assessmentQuestions": "Beoordelingsvragen",
      "outro": "Outro",
      "assessmentExplanation": "BEOORDELINGSTOELICHTING",
      "unsure": "Onzeker",
      "viewInKiku": "BEKIJK IN KIKU VOOR MEER DETAILS",
      "viewProfileLink": "Bekijk kandidaatprofiel in Kiku voor uitleg bij scores"
    }
  },
  "topbar": {
    "whatsNew": "Wat is nieuw",
    "help": "Help",
    "notifications": "Meldingen"
  },
  "extension_candidate_banner": {
    "description": "Bekijk kandidaatdetails.",
    "description_with_transcript": "Bekijk screeningtranscript & kandidaatdetails.",
    "open_in_kiku": "Openen",
    "dismiss": "Sluiten"
  },
  "languages": {
    "en": "Engels",
    "da": "Deens",
    "sv": "Zweeds",
    "de": "Duits",
    "fr": "Frans",
    "es": "Spaans",
    "nl": "Nederlands",
    "pl": "Pools",
    "fi": "Fins",
    "ro": "Roemeens"
  },
  "environmentBanner": {
    "development": "Ontwikkeling",
    "test": "Test"
  },
  "notFound": {
    "title": "Pagina niet gevonden",
    "description": "De pagina die u zoekt bestaat niet of is verplaatst.",
    "goHome": "Terug naar Kiku"
  },
  "candidateProfile": {
    "title": "Kandidaten",
    "cv": {
      "title": "CV / Resume",
      "upload": "CV uploaden",
      "replace": "CV vervangen",
      "uploadDescription": "Upload een CV om gestructureerde profielgegevens te extraheren",
      "uploadLimit": "Max 10 MB — PDF, DOCX, PNG, JPG, WEBP",
      "viewOriginal": "Origineel CV bekijken",
      "status": {
        "pending": "In wachtrij",
        "processing": "Verwerken...",
        "done": "Verwerkt",
        "failed": "Verwerking mislukt"
      },
      "parsed": {
        "title": "Geëxtraheerd profiel",
        "skills": "Vaardigheden",
        "experience": "Ervaring",
        "education": "Opleiding",
        "languages": "Talen",
        "certifications": "Certificeringen",
        "present": "Heden"
      },
      "errors": {
        "unsupportedType": "Niet-ondersteund bestandstype. Upload een PDF, DOCX, PNG, JPG of WEBP.",
        "tooLarge": "Bestand te groot. Maximale grootte is 10 MB.",
        "uploadFailed": "CV uploaden mislukt. Probeer het opnieuw."
      }
    }
  },
  "results": {
    "exportLabel": "Exporteren",
    "exportCsv": "CSV exporteren",
    "csv": {
      "headers": {
        "candidateName": "Naam kandidaat",
        "email": "E-mail",
        "role": "Rol",
        "stage": "Fase",
        "overallScore": "Totaalscore",
        "outcome": "Uitkomst",
        "eligibility": "Geschiktheid",
        "expectations": "Verwachtingen",
        "avgScore": "Gem. score",
        "interviewDate": "Interviewdatum",
        "status": "Status"
      }
    },
    "emptyTitle": "Nog geen resultaten",
    "emptyDescription": "Voltooide interviews verschijnen hier.",
    "columns": {
      "candidate": "Kandidaat",
      "stage": "Fase",
      "status": "Status",
      "score": "Score",
      "outcome": "Uitkomst",
      "eligibility": "Geschiktheid",
      "expectations": "Verwachtingen",
      "avgScore": "Gem. score",
      "interviewDate": "Interviewdatum",
      "question": "Vraag"
    },
    "statusLabels": {
      "pending": "In afwachting",
      "processing": "Verwerken",
      "completed": "Voltooid",
      "failed": "Mislukt",
      "no_interview": "Geen interview"
    },
    "questionSections": {
      "eligibility": "Geschiktheid",
      "job_preview": "Verwachtingen",
      "nice_to_have": "Mooi meegenomen",
      "assessment": "Beoordeling",
      "information": "Informatie"
    },
    "fields": {
      "reasoning": "Redenering",
      "evidence": "Bewijs",
      "response": "Antwoord",
      "avgScoreLabel": "Gem. score",
      "interviewDate": "Interviewdatum"
    }
  },
  "orgSettings": {
    "title": "Organisatie-instellingen",
    "branding": {
      "title": "Huisstijl",
      "logo": "Organisatielogo",
      "logoDescription": "Upload een logo om het standaard Kiku-logo in de navigatiebalk te vervangen.",
      "uploadLogo": "Logo uploaden",
      "removeLogo": "Logo verwijderen",
      "logoHint": "PNG, JPG, WebP of SVG. Max 2 MB.",
      "uploadSuccess": "Logo succesvol bijgewerkt",
      "removeSuccess": "Logo verwijderd",
      "uploadError": "Logo uploaden mislukt"
    },
    "timezone": {
      "title": "Tijdzone",
      "description": "Stel de standaard tijdzone in voor planning en weergave van datums.",
      "label": "Tijdzone",
      "saveSuccess": "Tijdzone bijgewerkt",
      "saveError": "Tijdzone bijwerken mislukt"
    },
    "save": "Wijzigingen opslaan"
  },
  "mcp": {
    "title": "MCP-integratie",
    "subtitle": "Verbind AI-assistenten met Kiku via het Model Context Protocol",
    "whatIsMcp": "Wat is MCP?",
    "whatIsMcpDescription": "Het Model Context Protocol (MCP) laat AI-assistenten zoals Claude, ChatGPT en andere tools direct met Kiku communiceren — vacatures bekijken, kandidaten inzien en uw wervingspipeline beheren via natuurlijke taal.",
    "serverUrl": "Server-URL",
    "copyUrl": "URL kopiëren",
    "copied": "Gekopieerd!",
    "availableTools": "Beschikbare tools",
    "toolListJobs": "Vacatures zoeken en weergeven met afdelingsnamen, filters voor status, instellingsstatus en afdeling.",
    "toolGetJob": "Alle details van een specifieke vacature ophalen, inclusief afdelingsnaam.",
    "toolCreateJob": "Maak een nieuwe vacature aan in een afdeling.",
    "toolAdvanceSetup": "Verplaats een vacature door de instellingsfases (concept, vragen_in_afwachting, gereed, actief).",
    "toolListApplications": "Sollicitaties voor een vacature weergeven met fasenamen, scoringsstatus en resultaat.",
    "toolGetInterviewResults": "AI-interviewresultaten ophalen voor een sollicitatie — score, resultaat en uitsplitsing per vraag met onderbouwing.",
    "toolGetPipelineSummary": "Pipeline-overzicht ophalen voor een vacature — aantal kandidaten per fase met geslaagd/gezakt totalen.",
    "setupTitle": "Instellen met Claude Desktop",
    "setupStep1": "Open Claude Desktop",
    "setupStep2": "Klik op Customize in de linkerzijbalk",
    "setupStep3": "Klik op Connectors, dan het +-icoon, dan Add custom connector",
    "setupStep4": "Voer Name: Kiku in en de hierboven getoonde server-URL",
    "setupStep5": "Klik op Add — Claude kan nu uw Kiku-gegevens gebruiken"
  }
}
